const ApplySettings = (app, store) => {
  store.$http = app.config.globalProperties.$http;

  app.config.globalProperties.$isBrowser =
    typeof window !== "undefined" ? true : false;
};

export default ApplySettings;
